import "core-js/modules/es6.string.fixed";

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from "react";
import { Link } from "gatsby";
import { Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink } from "reactstrap";
import Logo from "../../images/svg/logo_sinf_simp.inline.svg";
import NavbarStyles from "../../styles/common/navbar.module.css";

var NavWrapper = function NavWrapper(_ref) {
  var links = _ref.links,
      className = _ref.className,
      closeDrawer = _ref.closeDrawer;
  return React.createElement(Nav, {
    navbar: true,
    className: className
  }, links.map(function (_ref2) {
    var internal = _ref2.internal,
        url = _ref2.url,
        text = _ref2.text;
    return React.createElement(NavItem, {
      className: "px-2",
      key: text
    }, internal ? React.createElement(Link, {
      className: "nav-link " + NavbarStyles.navLink,
      activeClassName: NavbarStyles.navLinkActive,
      to: url,
      onClick: closeDrawer
    }, text) : React.createElement(NavLink, {
      className: NavbarStyles.navLink,
      href: url
    }, text));
  }));
};

var NavBar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavBar, _React$Component);

  function NavBar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.closeDrawer = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    _this.fixed = props.fixed;
    _this.transparent = props.transparent;
    _this.logo = props.logo;
    _this.state = {
      isOpen: false
    };
    _this.leftLinks = [{
      url: "/#sobre-nos",
      text: "Sobre nós",
      internal: true
    }, {
      url: "/#speakers",
      text: "Speakers",
      internal: true
    }, {
      url: "/#sponsors",
      text: "Sponsors",
      internal: true
    }, {
      url: "/#tickets",
      text: "Bilhetes",
      internal: true
    }, {
      url: "/#contactos",
      text: "Contactos",
      internal: true
    }];
    _this.rightLinks = [{
      url: "/program",
      text: "Programa",
      internal: true
    }, {
      url: "/equipa",
      text: "Equipa",
      internal: true
    }, {
      url: "/competicao-programacao",
      text: "Competição",
      internal: true
    }, {
      url: "https://2018.sinf.pt",
      text: "2018",
      internal: false
    }];
    return _this;
  }

  var _proto = NavBar.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return React.createElement("div", null, React.createElement(Navbar, {
      dark: true,
      fixed: this.fixed ? "top" : "",
      expand: "lg",
      className: NavbarStyles.navbar + (this.transparent && !this.state.isOpen ? " " + NavbarStyles.noBackground : "")
    }, React.createElement(Collapse, {
      isOpen: this.state.isOpen,
      navbar: true,
      className: " w-100 order-1 order-lg-0 dual-collapse2"
    }, React.createElement(NavWrapper, {
      className: "ml-0 align-items-center",
      links: this.leftLinks,
      closeDrawer: this.closeDrawer
    })), this.logo || this.state.isOpen ? React.createElement(Link, {
      className: "navbar-brand mx-auto order-0",
      to: "/"
    }, React.createElement(Logo, {
      fill: "#000",
      className: NavbarStyles.logo
    })) : "", React.createElement(Collapse, {
      isOpen: this.state.isOpen,
      navbar: true,
      className: "w-100 order-3 dual-collapse2"
    }, React.createElement(NavWrapper, {
      className: "ml-auto align-items-center",
      links: this.rightLinks,
      closeDrawer: this.closeDrawer
    })), React.createElement(NavbarToggler, {
      className: NavbarStyles.toggler,
      onClick: this.toggle
    })));
  };

  return NavBar;
}(React.Component);

export { NavBar as default };